import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=366e70c7&"
import script from "./TaskManage.vue?vue&type=script&lang=js&"
export * from "./TaskManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports